import axios from "axios";

const consultar = (request) => {
    return axios
        .post("https://api.winvest.ar/information/consultarPUC5", request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*'
                }
            }
        );
};

const delfos = {
    consultar
};

export default delfos
